<template>
    <Layout>
        <Header/>
        <Sidebar v-if="false"/>
        <div class="ivu-layout-wrapper">
            <Content>
                <router-view/>
            </Content>
        </div>
        <Password/>
        <ChangeUser/>
        <Prints/>
    </Layout>
</template>

<script type="text/javascript">
    import Header from '@/components/Header';
    import Sidebar from "../components/Sidebar";
    import Password from "../components/Password";
    import ChangeUser from "../components/ChangeUser";
    import Prints from "./prints/index";

    export default {
        components: {
            Header, Sidebar, Password, ChangeUser, Prints
        },
        data() {
            return {
            }
        },
        beforeDestroy() {
            this.$bus.off('verifyErrorTips');
        },
        mounted() {
            this.$bus.on('verifyErrorTips', (data, object) => {
                if (data){
                    this.$Message.error(object);
                }
            });
        },
        methods: {
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/dashboard.vue